export default __webpack_public_path__ + "static/media/zoom-100.800b6dbe.svg";